/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { EventPlanningCheckParams } from './eventPlanningCheckParams';

/**
 * Request model for event planning status check job
 */
export interface RunEventPlanningCheckJobRequest {
  type: 'event_planning_check';
  params: EventPlanningCheckParams;
  allowOverlappingJobs?: boolean;
}
